import { render, staticRenderFns } from "./MobFullIndex.vue?vue&type=template&id=00aafc85&scoped=true"
import script from "./MobFullIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MobFullIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobFullIndex.vue?vue&type=style&index=0&id=00aafc85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aafc85",
  null
  
)

export default component.exports